import type { Routes } from "@angular/router";
import { PaymentsList } from "./payments-list/payments-list";
import { inject } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { LayoutService } from "../../../services/layout.service";

export const paymentsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => PaymentsList,
    title: async () => {
      const title = await firstValueFrom(inject(LayoutService).systemTitle$);
      return `${title} - Área de Pagamentos`;
    }
  }
];
